import React from 'react';
import { Skeleton } from '../Skeleton';
import RelatedCardSkeleton from './RelatedCardSkeleton';

function LinkedContentSkeleton() {
  return (
    <div className="w-100 p-sm-4 p-3 overflow-hidden position-relative rounded-3 d-flex flex-column bg-extra-light clr_v3_sideBar_Card_variant-1-big">
      <div className="clr_v3_borderGraphics w-100 h-100 start-0 translate-middle-y top-50 position-absolute d-flex justify-content-between py-sm-4 py-3">
        <div
          className={`h-100 bg-primary rounded-4 clr_v3_borderGraphics__line`}
          style={{ '--bs-bg-opacity': 0.1 }}
        ></div>
        <div
          className={`h-100 bg-primary rounded-4 clr_v3_borderGraphics__line`}
          style={{ '--bs-bg-opacity': 0.1 }}
        ></div>
      </div>

      <div className="position-relative">
        <h2 className="fs-3 fw-semibold text-black mb-2">
          <Skeleton width={200} />
        </h2>
        <div className="clr_v3_TtlDivider position-relative bg-light me-auto rounded overflow-hidden">
          <span className="w-50 bg-primary position-absolute top-0 start-0 h-100"></span>
        </div>
        <div className="d-flex flex-column gap-sm-4 gap-3 mt-sm-4 mt-3">
          {[1, 2, 3, 4, 5].map(() => (
            <RelatedCardSkeleton type="small" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default LinkedContentSkeleton;
